export class DatabaseRecord {
    'name';
    'schemas';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "schemas",
            "baseName": "schemas",
            "type": "Array<SchemaRecord>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DatabaseRecord.attributeTypeMap;
    }
    constructor() {
    }
}
